import React from 'react';
import styles from './styles.module.css';
import { Backdrop } from '@mui/material';

function Grayout({ open }) {
  return <Backdrop open={open === true} className={styles.backdrop}></Backdrop>;
}

export default Grayout;
